export enum TrueFalse {
  TRUE = 1,
  FALSE = 0
}
